import React from 'react';

interface PageInfoProps {
  count: number;
  total: number;
  currentPage?: number;
  totalPages?: number;
  label?: string; // e.g., 'bonds', 'results', etc.
  extra?: React.ReactNode; // for additional info (e.g., search query)
  showPageInfo?: boolean; // whether to show page information
}

const PageInfo: React.FC<PageInfoProps> = ({ count, total, currentPage, totalPages, label = '', extra, showPageInfo = true }) => (
  <div className="page-info-bar">
    {label && <span>Showing {count} of {total} {label}</span>}
    {!label && <span>Showing {count} of {total}</span>}
    {showPageInfo && currentPage && totalPages && (
      <>
        <span className="page-info-separator">|</span>
        <span>Page {currentPage} of {totalPages}</span>
      </>
    )}
    {extra && <span className="page-info-extra">{extra}</span>}
  </div>
);

export default PageInfo; 